import { Row } from '@tanstack/react-table';
import { TenantLicenseUsage } from 'application/Shared/types/tenantLicenseUsage';
import { UserApp } from 'application/Shared/types/userApp';

import { ColumnFilter } from '../Table/types';

export const userAppLicenseTypesFilter: ColumnFilter<UserApp> = {
    clientSideFiltering: true,
    defaultOptions: [
        {
            options: ['None']
        }
    ],
    filterFn: (row, filterValue) => {
        const filterValueArray = Array.isArray(filterValue)
            ? filterValue
            : [filterValue];

        if (filterValueArray.length === 0) return true;

        const { licenseTypes } = row;

        return (
            (licenseTypes!.length === 0 && filterValueArray.includes('None')) ||
            licenseTypes!.some((licenseType) =>
                filterValueArray.includes(
                    licenseType['licenseTier+skuName'] ?? 'None'
                )
            )
        );
    }
};

export function licenseTypeFilter(
    row: Row<TenantLicenseUsage>,
    columnId: string,
    filterValue: string[]
): boolean {
    if (filterValue.length === 0) return true;
    return filterValue.includes(row.getValue(columnId) || 'None');
}
